export const getStripePublishableKey = (): string => {
  return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
};
